export default __webpack_public_path__ + "vie.863ef60.png";